	/******************************************************
		Helpers
	*******************************************************/
	//get one element
	var $ = function (selector) {
		return document.querySelector(selector);
	};
	//END

	// get one element with source
	var $s = function (src, selector) {
		return src.querySelector(selector);
	};
	// END

	// get all elements
	var $$ = function (selector) {
		return document.querySelectorAll(selector);
	};
	// END

	// get all elements with source
	var $$s = function (src, selector) {
		return src.querySelectorAll(selector);
	};
	// END

	// addEventListener for all element
	//et: element , fn: function , ev: event , els: elemnets , el: elemnts
	var $e = function (et, fn, ev) {
		if ($(et)) {
			let els = $$(et);
			for (let i = 0; i < els.length; i++) {
				let el= els[i];
				for (let e of ev) {
					el.addEventListener(e, fn);
				}
			}
		}
	}
	// END

	// is there element?
	var is = function (et, fn) {
		//et: element , fn: function
    	if ($(et)) {
      		fn;
    	}
  	}
  	// END

  	// get next element sibling
	var ne = function (et) {
		return et.nextElementSibling
	};
	// END

	// get previous element sibling
	var pe = function (et) {
		return et.previousElementSibling
	};
	// END

	// add classes to element
	var ca = function (et,cl) {
		return et.classList.add(cl);
	};
	// END

	// remove classes to element
	var cr = function (et,cl) {
		return et.classList.remove(cl);
	};
	// END

	// toggle classes to element
	var ct = function (et,cl) {
		return et.classList.toggle(cl);
	};
	// END

	// get element has contains class
	var cc = function (et,cl) {
		return et.classList.contains(cl);
	};
	// END

	/******************************************************
		END Helpers
	*******************************************************/

document.addEventListener('DOMContentLoaded', () => {
	console.log('| PAV.LEGAL |');


  	//show and hide navigation top bar
  	function nav_show_hide() {
	  	ct($('.nav'),'is-active');
	  	if($s(this,'a').dataset.img ==="open"){
	  	  	this.innerHTML = `<a href="#" data-img="close">
	  	  						<img src="./assets/images/icons/close.svg">
	  	  					  </a>`
	  	}else {
	  	  	this.innerHTML = `<a href="#" data-img="open">
							<img src="./assets/images/icons/menu.svg">
						  </a>`
	  	}
  	}

	$e('.navigation-bar > .burger', nav_show_hide,['click']);
	// END
	
	// change pointer-events="auto" hd: navigation item has dropdown
 	function hd_show_hide(e) {
 		//els: elements , el: element , pel: parent element
 		if (e.type === "mouseenter" && window.innerWidth > 769){
 			ca($s(this,'.nav-dropdown-items'), 'is-active');
 		} else if(e.type === "mouseleave" && window.innerWidth > 769){
 			cr($s(this,'.nav-dropdown-items'), 'is-active');
 		} else if (e.type === "click"){
 			let pel = this.parentElement;
 			let els = $$s(pel,'.nav-dropdown-items');
			for (let el of els) {
				cr(el, 'is-active');
			}
 			ct($s(this,'.nav-dropdown-items'), 'is-active');
 		}
  	}

	$e('.has-dropdown', hd_show_hide,['click','mouseenter','mouseleave']);
	// END

  	// slider contorller
  	function slider() {

		function left(e) {
		    const cls = ['is-active'];
		    let el = this.closest('.slider');
		    let all_el = $$s(el, '.item');
		    let this_el = $s(el, '.is-active');
		    cr(this_el,'is-active');
		    ne(this_el) ? ca(ne(this_el), ...cls) : ca(all_el[0], ...cls);
		    all_el = $$s(el, '.item');
		    this_el = $s(el, '.is-active');
		    const index = Array.from(all_el).indexOf(this_el);
		    dots(this, index);
		}

		function right(e) {
		    const cls = ['is-active'];
		    let el = this.closest('.slider');
		    let all_el = $$s(el, '.item');
		    let this_el = $s(el, '.is-active');
		    cr(this_el,'is-active');
		    pe(this_el) ? ca(pe(this_el), ...cls) : ca(all_el[all_el.length - 1], ...cls);
		    all_el = $$s(el, '.item');
		    this_el = $s(el, '.is-active');
		    const index = Array.from(all_el).indexOf(this_el);
		    dots(this, index);
		}

		function dot(e) {
		    const cls = ['is-active'];
		    let el = this.closest('.slider');
		    let all_el_dot = $$s(el, '.dot');
		    const index = Array.from(all_el_dot).indexOf(this);
		    let all_el = $$s(el, '.item');
		    for (let i = 0; i < all_el_dot.length; i++) {
		    	if(cc(all_el_dot[i], 'is-active')){
		      		all_el_dot[i].innerHTML = `<img src="./assets/images/icons/dot.svg">`;
		      	}
		      	cr(all_el_dot[i], ...cls);
		      	cr(all_el[i], ...cls);
		    }
		    ca(all_el_dot[index], ...cls);
		    ca(all_el[index], ...cls);
		    all_el_dot[index].innerHTML = `<img src="./assets/images/icons/circle-shape-outline.svg">`;
		}

		function dots(this_el, index) {
		    const cls = ['is-active'];
		    let el = this_el.closest('.slider');
		    let all_el_dot = $$s(el, '.dot');
		    if(all_el_dot.length > 0){
			    for (let i = 0; i < all_el_dot.length; i++) {
			      	if(cc(all_el_dot[i], 'is-active')){
			      		all_el_dot[i].innerHTML = `<img src="./assets/images/icons/dot.svg">`;
			      	}
			      	cr(all_el_dot[i], ...cls);
			    }
			    ca(all_el_dot[index], ...cls);
			    all_el_dot[index].innerHTML = `<img src="./assets/images/icons/circle-shape-outline.svg">`;
			}
		}

		function thumbnail(e) {
		    const cls = ['is-active'];
		    let el = this.parentElement;
		    let all_el_itm = $$s(el, '.item');
		    const index = Array.from(all_el_itm).indexOf(this);
		    let el_sl = pe(el);
		    let el_sl_itms = $$s(el_sl, '.item');

		    for (el of el_sl_itms) {
		    	cr(el, ...cls);
		    }
		    ca(el_sl_itms[index], ...cls);
		    dots(el_sl_itms[index], index);
		}

		function resize_img_stretch() {
		    let el = $('.slider');
		    let all_el_img = $$s(el, '.image');
		    let el_itm = $s(el, '.items');
		    let h;
		    for (let i = 0; i < all_el_img.length; i++) {
		    	let a = 0;
		    	let img_w = all_el_img[i].width;
		    	let img_h = all_el_img[i].height;
		    	let win_w = window.innerWidth;
		    	if(win_w > img_w){
		    		a = win_w / img_w;
		    		h = img_h * a;
		    		el_itm.style.maxHeight = `${h}px`;
		    	}else if (win_w < img_w){
		    		a = img_w / win_w;
		    		h = img_h / a;
		    		el_itm.style.maxHeight = `${h}px`;
		    	}
		    }
		}

		$e('.thumbnail > .item', thumbnail ,['click']);
		$e('.slider > .left-arrow', left ,['click']);
		$e('.slider > .right-arrow', right ,['click']);
		$e('.slider > .dots > .dot', dot ,['click']);
		if($('.slider')){
			resize_img_stretch();
			window.addEventListener('resize', resize_img_stretch);
		}
  	}

	is('.slider', slider());
	// END

	// featured carousel contorller
  	function featured_carousel() {

		function left(e) {
			let next = ne(this);
			cr(next,'is-disabled');
			let fe = this.parentElement;
			let vi = $s(fe,'.view');
			let vi_wid = vi.offsetWidth;
			let el = $s(fe,'.items');
			let el_wid = el.offsetWidth;
			let all_el =$$s(el,'.group');
			let gr_wid = all_el[0].offsetWidth;
			let left = el.offsetLeft;
		    left -= (gr_wid + 20);
			el.style.left = `${left}px`;
			if((vi_wid-el_wid) > left){
		    	ca(this,'is-disabled');
		    }
		}

		function right(e) {
			let prev = pe(this);
			cr(prev,'is-disabled');
			let fe = this.parentElement;
			fe = $s(fe,'.view');
			let el = $s(fe,'.items');
			let all_el =$$s(el,'.group');
			let gr_wid = all_el[0].offsetWidth;
			let left = el.offsetLeft;
			left += (gr_wid + 20);
			el.style.left = `${left}px`;
			if (left == 0) {
				ca(this,'is-disabled');
			}
		}

		function resize_item_width() {
			let fe_all = $$('.featured-carousel');
			for(let fe of fe_all){
				let vi = $s(fe,'.view');
				let vi_wid = vi.offsetWidth;
				let its = $s(vi,'.items');
				its.style.left = `0px`;
				let ar_r = $s(fe,'.right-arrow');
				ca(ar_r,'is-disabled');
				let ar_l = $s(fe,'.left-arrow');
				cr(ar_l,'is-disabled');
				let gr_all = $$s(its,'.group');
				let wid = 0;
				if(vi_wid < 800){
					wid = vi_wid - 40;
				}else if(vi_wid > 799 && vi_wid < 1201){
					wid = (vi_wid / 2) - 30;
				}else if(vi_wid > 1200) {
					wid = (vi_wid / 3) - 25;
				}
				for(let gr of gr_all){
					gr.style.width = `${wid}px`;
				}
			}
		}

		if($('.featured-carousel')){
			resize_item_width();
			window.addEventListener('resize', resize_item_width);
		}
		$e('.featured-carousel > .left-arrow', left ,['click']);
		$e('.featured-carousel > .right-arrow', right ,['click']);
  	}

	is('.featured-carousel', featured_carousel());
	// END

	// show and hide modal
 	function modal(e) {
 		let d_m = this.dataset.modal;
 		let el_mo = $$('.modal');
 		for(let el of el_mo){
 			if(el.dataset.name === d_m){
 				ca(el,'is-active');
 			}
 		}
		$e('.modal-remove', modal_close,['click']);
		function modal_close(e) {
			cr(this.parentElement,'is-active');
		}
  	}

	$e('.modal-trigger', modal,['click']);
	// END

});
